/* Lisa Kookt — cart drawer enhancements:
 * 1) dataLayer tracking on cross-sell / bundle suggestions
 * 2) AJAX add-to-cart from suggestion forms, with scroll-to + highlight of the new line
 * 3) swipe-to-dismiss on mobile (drag the drawer to the right to close)
 * Delegated on document so it survives the drawer re-rendering after each add.
 */
(function(){
  if (window.lkCartInit) return;
  window.lkCartInit = true;
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function(e){
    var node = e.target.closest('[data-lk-xsell-id],[data-lk-bundle-id]');
    if(!node) return;
    var isX = node.hasAttribute('data-lk-xsell-id');
    var isAdd = !!e.target.closest('button,[type="submit"],.lk-sugg__add');
    window.dataLayer.push({event:(isX?'lk_xsell':'lk_bundle')+(isAdd?'_add':'_click'),lk_id:node.getAttribute(isX?'data-lk-xsell-id':'data-lk-bundle-id'),lk_title:node.getAttribute(isX?'data-lk-xsell-title':'data-lk-bundle-title')});
  }, true);

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-lk-add]');
    if(!form) return;
    e.preventDefault();
    e.stopPropagation();
    var idEl = form.querySelector('[name="id"]');
    if(!idEl) return;
    var addedId = String(idEl.value);
    var btn = form.querySelector('button');
    if(btn){ btn.setAttribute('disabled','disabled'); }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    // Op de volledige winkelwagen-pagina: AJAX toevoegen en daarna herladen,
    // zodat de productlijst, subtotaal en cadeaus meteen kloppen (geen drawer).
    if(document.body.classList.contains('template-cart')){
      fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: idEl.value, quantity:1}]})})
        .then(function(){ window.location.reload(); })
        .catch(function(){ if(btn){ btn.removeAttribute('disabled'); } });
      return;
    }
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: idEl.value, quantity:1}], sections:['cart-drawer','cart-icon-bubble'], sections_url: window.location.pathname})})
    .then(function(r){return r.json();})
    .then(function(data){
      if(data && data.sections){
        if(data.sections['cart-drawer']){
          var tmp=document.createElement('div'); tmp.innerHTML=data.sections['cart-drawer'];
          var nn=tmp.querySelector('#CartDrawer'); var cur=document.querySelector('#CartDrawer');
          if(nn && cur){ cur.innerHTML=nn.innerHTML; }
          var dr=document.querySelector('cart-drawer'); if(dr){ dr.classList.remove('is-empty'); }
          var items=document.querySelector('cart-drawer-items');
          if(items){
            requestAnimationFrame(function(){
              // The added line renders at the bottom (template uses reversed order).
              // Target the exact added variant so the highlight always lands right.
              var row=items.querySelector('[data-quantity-variant-id="'+addedId+'"]');
              row = row ? row.closest('.cart-item') : null;
              if(!row){ var rows=items.querySelectorAll('.cart-item'); row=rows[rows.length-1]; }
              // Jump straight to the bottom (no animated scroll) so it's simply there.
              items.scrollTop=items.scrollHeight;
              if(row){
                row.classList.add('lk-just-added');
                setTimeout(function(){ row.classList.remove('lk-just-added'); }, 1700);
              }
            });
          }
        }
        if(data.sections['cart-icon-bubble']){
          var t2=document.createElement('div'); t2.innerHTML=data.sections['cart-icon-bubble'];
          var nb=t2.querySelector('#cart-icon-bubble')||t2.firstElementChild; var cb=document.querySelector('#cart-icon-bubble');
          if(nb && cb){ cb.innerHTML=nb.innerHTML; }
        }
      }
    })
    .catch(function(){ if(btn){ btn.removeAttribute('disabled'); } });
  }, true);

  /* swipe-to-dismiss (mobile) */
  var drag=null;
  function openDrawer(){
    var dr=document.querySelector('cart-drawer');
    if(!dr) return null;
    try{ if(getComputedStyle(dr).visibility==='hidden') return null; }catch(_){}
    var panel=dr.querySelector('.drawer__inner');
    return panel ? {dr:dr, panel:panel} : null;
  }
  document.addEventListener('touchstart', function(e){
    if(e.touches.length!==1) return;
    var o=openDrawer(); if(!o) return;
    if(!e.target.closest('.drawer__inner')) return;
    var t=e.touches[0];
    drag={x:t.clientX,y:t.clientY,panel:o.panel,dr:o.dr,active:false,dx:0};
  }, {passive:true});
  document.addEventListener('touchmove', function(e){
    if(!drag) return;
    var t=e.touches[0];
    var dx=t.clientX-drag.x, dy=t.clientY-drag.y;
    if(!drag.active){
      if(Math.abs(dx)<10 && Math.abs(dy)<10) return;
      if(Math.abs(dy)>=Math.abs(dx)){ drag=null; return; }
      drag.active=true;
      drag.panel.style.transition='none';
    }
    if(dx<0) dx=0;
    drag.dx=dx;
    drag.panel.style.transform='translateX('+dx+'px)';
    if(e.cancelable) e.preventDefault();
  }, {passive:false});
  document.addEventListener('touchend', function(){
    if(!drag) return;
    var panel=drag.panel, dr=drag.dr, dx=drag.dx, active=drag.active;
    drag=null;
    if(!active) return;
    var w=panel.offsetWidth||320;
    if(dx > Math.min(130, w*0.32)){
      // Let the theme close it (dim + slide handled by the sped-up CSS transitions).
      try{ if(typeof dr.close==='function'){ dr.close(); } else { var cb=dr.querySelector('.drawer__close'); if(cb) cb.click(); } }catch(_){}
      panel.style.transition='transform .25s ease';
      panel.style.transform='translateX(110%)';
      setTimeout(function(){ panel.style.transition=''; panel.style.transform=''; },320);
    } else {
      panel.style.transition='transform .2s ease';
      panel.style.transform='';
      setTimeout(function(){ panel.style.transition=''; },220);
    }
  }, {passive:true});
})();

/* Lisa Kookt — winkelmand na toevoegen naar ONDEREN scrollen.
 * De drawer toont items in omgekeerde volgorde (cart.items reversed): een net
 * toegevoegd product staat ONDERAAN. Toevoegen vanuit de drawer-suggesties scrolt
 * daar al heen (zie hierboven), maar toevoegen vanaf een collectie/productpagina
 * opent de drawer bovenaan. Hier vangen we ELKE cart-toevoeging af en scrollen we
 * de drawer naar onderen, zodat het toegevoegde product zichtbaar is.
 * Aantal-wijzigingen/verwijderen binnen de winkelmand (source 'cart-items') slaan we over.
 */
(function(){
  if (window.lkCartScrollBottomInit) return;
  window.lkCartScrollBottomInit = true;

  function scrollDrawerBottom(){
    var items = document.querySelector('cart-drawer-items');
    if (!items) return;
    items.scrollTop = items.scrollHeight;
  }
  function scheduleScroll(){
    // Meerdere pogingen: de drawer wordt her-gerenderd en opent met een animatie,
    // dus we herhalen ~0.7s lang zodat we na de re-render/open onderaan landen.
    var tries = 0;
    (function tick(){
      scrollDrawerBottom();
      if (++tries < 9) setTimeout(tick, 80);
    })();
  }
  function start(){
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event){
        var src = event && event.source;
        if (src === 'cart-items' || src === 'cart-note') return; // geen scroll bij wijzigen/verwijderen in de mand
        scheduleScroll();
      });
    }
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();

/* Lisa Kookt — aantal-stepper toevoegen aan de homepage "Shop bestsellers per categorie"
 * (top-product / card-product-banner). Dat snippet rendert geen quantity-stepper, terwijl
 * de andere homepage-secties (card-product) die wel hebben. We klonen de ECHTE stepper van
 * een card-product-kaart elders op de pagina (juiste iconen + Dawn quantity-input werking)
 * en zetten die per bannerkaart met het juiste form-id in de knoppengroep. */
(function(){
  if (window.lkTabStepperInit) return;
  window.lkTabStepperInit = true;

  function addSteppers(){
    var groups = document.querySelectorAll('.product-tab-item .wbbtngrp');
    if(!groups.length) return;
    var tpl = document.querySelector('.wbbtngrp quantity-input.card-quantity');
    var n = 0;
    groups.forEach(function(grp){
      if(grp.querySelector('quantity-input')) return;      // heeft er al een
      var form = grp.querySelector('form');
      if(!form) return;                                    // geen toevoegen-formulier -> overslaan
      var formId = form.getAttribute('id');
      var qi;
      if(tpl){
        qi = tpl.cloneNode(true);
      } else {
        qi = document.createElement('quantity-input');
        qi.className = 'quantity card-quantity';
        qi.innerHTML = '<button class="quantity__button no-js-hidden" name="minus" type="button" aria-label="min">−</button>'
          + '<input class="quantity__input" type="number" name="quantity" min="1" value="1">'
          + '<button class="quantity__button no-js-hidden" name="plus" type="button" aria-label="plus">+</button>';
      }
      var input = qi.querySelector('input');
      if(input){
        input.value = '1';
        input.setAttribute('id', 'lk-tabqty-' + (n++));
        if(formId){ input.setAttribute('form', formId); } else { input.removeAttribute('form'); }
        input.removeAttribute('data-cart-quantity');
      }
      grp.insertBefore(qi, grp.firstChild);                // CSS order regelt de weergave (stepper links van de knop)
    });
  }

  function start(){ addSteppers(); document.addEventListener('shopify:section:load', addSteppers); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
